import { Box, Image, rem, Stack, Text, Title } from '@mantine/core';
import { openContextModal } from '@mantine/modals';
import dayjs from 'dayjs';
import React from 'react';
import type { MyReward } from '../api/reward/types';
import { ModalName } from '@/components/modals';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { getBrandName } from '@/lib/utils';

type Props = {
  isUsed?: boolean;
  rewardData: MyReward;
};

export default function MyRewardCard({ isUsed, rewardData }: Props) {
  const isMobile = useIsMobile();

  const openMyRewardDetail = () => {
    openContextModal({
      modal: ModalName.MyRewardDetail,
      innerProps: { rewardId: rewardData.id },
      // h: 'fit-content',
      closeOnClickOutside: false,
      withCloseButton: false,
      fullScreen: isMobile,
      centered: true,
      maw: rem(440),
      w: '100%',
      styles: {
        root: {
          zIndex: 1,
        },
        title: {
          flex: 1,
          marginLeft: isMobile ? 0 : rem(14),
          textAlign: 'center',
          fontSize: 18,
          fontWeight: 700,
        },
        header: {
          minHeight: isMobile ? rem(45) : rem(56),
          padding: isMobile ? '0px 16px' : '0px 24px',
          borderBottom: `1px solid var(--mantine-color-neutral-0)`,
        },
        body: {
          padding: 0,
        },
        content: {
          minHeight: rem(600),
          maxHeight: isMobile ? 'auto' : rem(600),
        },
      },
    });
  };

  return (
    <>
      <Box
        onClick={openMyRewardDetail}
        className={`flex h-[100px] cursor-pointer rounded bg-white p-2 ${isUsed ? 'grayscale' : ''}`}
      >
        <div className="relative border-y-0 border-l-0 border-r border-dashed border-r-neutral-30 pr-2">
          <div className="absolute right-[-6px] top-[-14px] size-3 rounded-full bg-neutral-10"></div>
          <div className="absolute bottom-[-14px] right-[-6px] size-3 rounded-full bg-neutral-10"></div>
          <div className="!h-[84px] !w-[84px] overflow-hidden rounded">
            <Image
              src={
                rewardData?.reward_policy?.image_url &&
                // eslint-disable-next-line regexp/no-unused-capturing-group
                /^(https?:\/\/)/i.test(rewardData?.reward_policy?.image_url)
                  ? rewardData?.reward_policy?.image_url
                  : `/static/images/rewards/rewards.webp`
              }
              alt="card"
              className="!h-full !object-cover"
            />
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex flex-1 flex-col justify-between pl-2">
            <Stack gap={2}>
              <Text fz={12}>{getBrandName(rewardData.reward_policy)}</Text>
              <Title order={5} fz={15} lineClamp={2}>
                {rewardData?.reward_policy?.title?.vi}
              </Title>
            </Stack>
            <div className="flex items-center justify-between">
              <div className="text-[10px] leading-[14px] text-neutral-40">
                {/* {!isUsed
                ? t('myReward.dueDate')
                : t('myReward.useOn') || t('myReward.expiredOn')} */}
                &nbsp;
                {dayjs(rewardData?.valid_time).format('DD/MM/YYYY')}
              </div>
              {/* {!isEmbed &&
                (rewardData?.reward_policy?.type === RewardPolicyType.AHAMOVE ||
                  isUsed) && (
                  <Button
                    size="small"
                    disabled={isUsed}
                    color="primary"
                    fill="none"
                    className="!px-2"
                    onClick={(e) => navigateUseCard(e, rewardData)}
                  >
                    <span className="text-sm font-bold">
                      {isUsed
                        ? t('myReward.buttonInvalid')
                        : t('myReward.buttonActive')}
                    </span>
                  </Button>
                )} */}
            </div>
          </div>
        </div>
      </Box>
    </>
  );
}
